function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Ruimte-beschikbaar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ruimte-beschikbaar",
  transform: "translate(21.000000, 5.000000)",
  stroke: "#9CE450",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,8.74859287 C16,13.1685929 12.4186667,16.7485929 8,16.7485929 C3.58133333,16.7485929 0,13.1685929 0,8.74859287 C0,4.3299262 3.58133333,0.748592871 8,0.748592871 C12.4186667,0.748592871 16,4.3299262 16,8.74859287 Z",
  id: "Stroke-1"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-3",
  points: "12 6.0819262 6.66666667 11.4152595 4 8.74859287"
})), /*#__PURE__*/React.createElement("g", {
  id: "smart-house-open-door-copy-3",
  transform: "translate(3.000000, 2.000000)",
  stroke: "#485156",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.9473684,20.7518797 L18.9473684,28.1954887 C18.9473684,29.5658193 17.8701588,30.6766917 16.5413534,30.6766917 L11.7293233,30.6766917",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.9473684,2.55584676 C18.9473684,1.14429157 17.8167003,0 16.4219506,0 L0.841805954,0 C0.376889363,0 0,0.381430524 0,0.851948921 L0,30.7212781 C0.00190101332,31.0404815 0.179956428,31.3318281 0.461309663,31.4761048 L9.64877985,35.1002955 C10.037782,35.2541541 10.4767917,35.2033905 10.8214762,34.9646941 C11.1661608,34.7259978 11.371923,34.3302525 11.3711148,33.907567 L11.3711148,5.9977204 C11.3699351,5.46612415 11.0432808,4.99094327 10.5511958,4.80499191 L0.00673444763,0.845133329",
  id: "Path"
})));
function SvgAssetAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Ruimte beschikbaar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetAvailable);
export default __webpack_public_path__ + "static/media/asset-available.4a01e29378863ce7aed9c47390be0ea8.svg";
export { ForwardRef as ReactComponent };